import React from "react";
import { Outlet } from "react-router-dom";
import NavBar from "../components/NavBar/NavBar";

const RootPage = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default RootPage;
